export const SMALL_SCREEN_SIZE = "768px";
export const ACCEPTED_IMAGE_TYPES = ["image/png", "image/jpg", "image/jpeg"];
export const MAX_IMAGE_SIZE = 4;